export default __webpack_public_path__ + "static/media/landing-image-yellow.dcce6b66.svg";